import { Navigate } from 'react-router-dom'
import { usePermissions } from '@/hooks/usePermissions'

interface RoleGuardProps {
  children: React.ReactNode
  require: keyof ReturnType<typeof usePermissions>
  redirectTo?: string
}

export function RoleGuard({ children, require, redirectTo }: RoleGuardProps) {
  const perms = usePermissions()

  // Still loading — role not yet fetched from DB
  if (perms.role === null) return null

  if (!perms[require]) {
    const fallback = redirectTo ?? (perms.canAccessBlog ? '/blog' : '/')
    return <Navigate to={fallback} replace />
  }

  return <>{children}</>
}
